import { GameRoundData, LeaderBoard, Ocb, PlayerCategoryData, PlayerScorecard, TeamRoundScores, TeamScores } from './../../../../data/mygolf.data';
import { SessionActions } from './../../../../redux/session/session-actions';

import { SessionInfo } from './../../../../data/authentication-info';
import { ConnectionService } from './../../../../providers/connection-service/connection-service';
import { AuthenticationService } from './../../../../authentication-service';
import { ScorecardService } from './../../../../providers/scorecard-service/scorecard-service';
import { PlainScorecard } from './../../../../data/scorecard';
import { SearchCriteria } from './../../../../data/search-criteria';

import { MessageDisplayUtil } from './../../../../message-display-utils';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ActionSheetController,
  AlertController,
  // Events,
  LoadingController,
  ModalController,
  NavController,

  Platform,
  ToastController,
} from '@ionic/angular';
import { isPresent } from 'src/providers/common-service';

import {
  CompetitionCategory,
  CompetitionDetails,
  CompetitionInfo,
  CompetitionTeams,
  createLeaderboardDetails,
  Leaderboard,
  LeaderboardPlayer,
  Teams,
} from './../../../../data/competition-data';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { adjustViewZIndex } from 'src/globals';
import { SessionDataService } from 'src/redux/session';
import { Location } from '@angular/common';
import { CompetitionData, CompetitionRound } from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { GameRoundInfo } from 'src/data/game-round';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CommonProvider } from '../../commonServices/common';

import * as global from 'src/globals';
import { Subscription } from 'rxjs';
import { SUBSCRIBE_COMP_SHOW_LEADERBOARD, WebsocketActions } from 'src/redux/wstomp';

export interface LeaderboardPlayerExt extends LeaderboardPlayer {
  showScores?: boolean;
  competitionRound?: Array<CompetitionRound>;
  showStrokes?: boolean;
}
@Component({
  selector: 'app-competition-leaderboard',
  templateUrl: './competition-leaderboard.page.html',
  styleUrls: ['./competition-leaderboard.page.scss'],
})
export class CompetitionLeaderboardPage implements OnInit {
  searchCriteria: SearchCriteria;
  competition: CompetitionInfo & CompetitionData;
  leaderboards: Leaderboard | LeaderBoard;
  // filteredPlayers: Array<LeaderboardPlayer> = new Array<LeaderboardPlayer>();
  filteredPlayers: Array<LeaderboardPlayerExt> = new Array<LeaderboardPlayerExt>();
  //leaderboardPlayers: Array<LeaderboardPlayer> =  new Array<LeaderboardPlayer>();
  leaderboardPlayers: Array<LeaderboardPlayer> = new Array<LeaderboardPlayer>();
  roundNo: number = 1;
  searchQuery: string = '';
  visible: boolean;

  categories: Array<CompetitionCategory> = new Array<CompetitionCategory>();
  selectedCategoryName: string = '';
  scoringFormat: string;
  details: CompetitionDetails;
  selectedOrderBy: number;
  category: Array<CompetitionCategory> = new Array<CompetitionCategory>();
  errorObj: Leaderboard;

  showSortBy: string = 'Gross';
  showCategoryName: string;
  showRoundNo: string = 'Overall';

  selectedSortBy: number = 2;
  selectedCategoryId: string = '';
  selectedRoundNo: number;

  scorecard: PlainScorecard;

  compTeams: CompetitionTeams;

  private needRefresh: boolean = true;

  sortToggle: boolean = true;

  refreshedAttempt: boolean = false;

  hideHomeButton: boolean = false;
  showLogout: boolean = false;
  doneRefresh: boolean = false;
  errorMsg: string = '';
  session: SessionInfo;

  showTeam: boolean = false;
  showEventMode: string = '';
  appFooterHide: boolean = true;

  filteredByScoreType: string = 'G';

  compId: number

  constructor(
    private router: Router,
    public nav: NavController,
    private renderer: Renderer2,
    // private keyboard: Keyboard,
    private connService: ConnectionService,
    private modalCtl: ModalController,
    private loadingCtl: LoadingController,
    private toastCtl: ToastController,
    private actionSheetCtl: ActionSheetController,
    private auth: AuthenticationService,
    private compService: CompetitionService,
    // private events: Events,
    private platform: Platform,
    private sessionService: SessionDataService,
    private sessionActions: SessionActions,
    private scorecardService: ScorecardService,
    private alertCtrl: AlertController,
    private route: ActivatedRoute,
    private location: Location,
    private flightService: ClubFlightService,
    private mg2uUtils: mygolfUtils,
    private websocketActions: WebsocketActions

  ) {

    //
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick()
    }
    this.searchCriteria = compService.getSearch();
    this.showCategoryName = "All Categories";
    this.hideHomeButton = this.router.getCurrentNavigation().extras.state.hideHomeButton;
    this.showLogout = this.router.getCurrentNavigation().extras.state.showLogout;
    if (!isPresent(this.searchCriteria.competitionLeaderboardSortBy))
      this.searchCriteria.competitionLeaderboardSortBy = 2;
    this.selectedOrderBy = 2;//this.searchCriteria.competitionLeaderboardSortBy;
    this.selectedSortBy = this.selectedOrderBy;

    if (!isPresent(this.searchCriteria.competitionLeaderboardGroupBy)) {
      this.searchCriteria.competitionLeaderboardGroupBy = '';
    }
    this.searchQuery = '';
    this.visible = false;


    if (this.router.getCurrentNavigation().extras.state.leaderboards) {
      this.competition = this.router.getCurrentNavigation().extras.state.competition;
      this.compId = this.router.getCurrentNavigation().extras.state.compId;
      this.scoringFormat = this.competition.scoringFormat;
      this.leaderboards = this.router.getCurrentNavigation().extras.state.leaderboards;
      this.leaderboardPlayers = this.router.getCurrentNavigation().extras.state.leaderboardPlayers;
      this.filteredPlayers = this.leaderboardPlayers;
      if (this.filteredPlayers)
        this.filteredPlayers.forEach((fp: LeaderboardPlayerExt) => {
          fp.showScores = false;
        })
      this.roundNo = this.router.getCurrentNavigation().extras.state.roundNo;
      this.selectedRoundNo = this.roundNo;
      this.showRoundNo = "Round " + String(this.roundNo);
      this.categories = this.router.getCurrentNavigation().extras.state.categories;
      this.compService.setLeaderboardFilter(
        this.selectedOrderBy,
        this.roundNo
      );
      if (this.competition.teamEvent) {
        this.showTeam = this.router.getCurrentNavigation().extras.state.showTeam;
        if (this.showTeam)
          this.showEventMode = "View Individual";
        else
          this.showEventMode = "View Teams";
      }
      this.compData = this.router.getCurrentNavigation().extras.state.compData;
      // this.refreshLeaderboard(null);
    } else {
      this.competition = this.router.getCurrentNavigation().extras.state.competition;
      this.roundNo = this.router.getCurrentNavigation().extras.state.roundNo;
      this.selectedRoundNo = this.roundNo;
      this.showRoundNo = "Round " + String(this.roundNo);

      this.scoringFormat = this.competition.scoringFormat;
      // this.refreshCompetitionDetails();


    }
    if(this.router.getCurrentNavigation().extras.state?.compData) {
      this.compData = this.router.getCurrentNavigation().extras.state.compData;
    }
    this.leaderboards = createLeaderboardDetails();
    this.errorObj = createLeaderboardDetails();


    this.initWebsocketActions();

  }

  compData: CompetitionData;
  ngOnInit() {
    if (this.needRefresh) {
      this.route.queryParams.subscribe((params: any) => {
        if (!params.leaderboards) this._setLeaderboardFilter();
        else {
          this._setLeaderboardFilter(true);
          this.refreshCompetitionDetails();
        }
      })
      // this.refreshLeaderboard(null);

    }

    if(this.compService.getCompData()) {
      this.compData = this.compService.getCompData();
    } else if(this.compData) {
      this.compService.setCompData(this.compData);
    }
    if(this.compData?.ocbs) {
      this.compOCBs = this.compData.ocbs;
      this.compOCBs.forEach((ocb) => {
        if(ocb?.roundInfo) ocb.mergedDetails = 'R'+ocb?.roundInfo?.roundNo+'-'+ocb?.details
        else ocb.mergedDetails = ocb.details || ocb?.ocb.details
      });
    }
    if(this.compData?.categories) {
      this.compData.categories.forEach((category)=>{
        this.compPlayerCategories.push(category.playerCategory);
      })
      this.compPlayerCategories.sort((a,b)=> a.displaySequence - b.displaySequence);
    }
    console.debug("init comp leaderboard ", this.compData, this.router.getCurrentNavigation().extras)
  }

  ionViewDidEnter() {
    this.refreshCompetitionDetails();
   }

  ionViewDidLeave() {
    if(this.subShowLeaderboard) {
      this.subShowLeaderboard.unsubscribe();
      this.subShowLeaderboard = null;
    }
  }

  toggleTeamEvent(showTeam?: boolean) {
    if (this.showTeam) {
      this.showTeam = false;
      this.showEventMode = 'View Teams';
    } else if (!this.showTeam) {
      this.showTeam = true;
      this.showEventMode = 'View Individuals';
    }
    this._setLeaderboardFilter();
  }

  async deriveSession() {
    this.session = await this.sessionService.getSession().toPromise();
  }
  toggleSearch() {
    this.visible = !this.visible; //searchBar;//
  }
  onSearchCancel() {
    this.toggleSearch();
    // if (this.platform.is('ios') && this.platform.is('capacitor'))
    // this.keyboard.close();
  }

  // async onOptionClick() {

  //   let option =await this.modalCtl.create({
  //     mo
  //     categories: this.categories,
  //     totalRounds: this.competition.totalRounds,
  //     currentRound: this.roundNo,
  //     compId: this.competition.competitionId,
  //     scoringFormat: this.scoringFormat
  //   });
  //   // option.onDidDismiss((roundNumber: number, category: Array<CompetitionCategory>) => {
  //   option.onDidDismiss((data: any) => {
  //     if (data.roundNumber >= 0) {
  //       this.roundNo = data.roundNumber;
  //       this.onRefreshClick(null);
  //     }
  //     this.category = data.selectedCategory;//category;

  //   });
  //   option.present()

  // }

  logout() {
    this.sessionActions.logout();
  }

  public onHomeClick() {
    this.router.navigate(['tabs/player-home']);

  }

  onRefreshClick(refresher) {
    this.refreshLeaderboard(refresher);
    this.refreshCompData();
    // this.compService.refreshCompData().then((compData: any)=>{
    //   if(compData) this.compData;
    // })
    // if(this.compService.refreshCompData()) {
    //   this.compData = this.compService.getCompData();
    // }
  }

  onSearchInput(searchbar) {
    if (this.searchQuery && this.searchQuery.length > 0) {
      if(this.showTeam) {

        this.filteredPlayers = this.leaderboardPlayers.filter(
          (p: LeaderboardPlayer) => {
            return (
              (
               p.playerName.toLowerCase()
              ).indexOf(this.searchQuery.toLowerCase()) >= 0
            );
          }
        );
      } else {
        this.filteredPlayers = this.leaderboardPlayers.filter(
          (p: LeaderboardPlayer) => {
            return (
              (
                p.lastName.toLowerCase() +
                ' ' +
                p.firstName.toLowerCase()
              ).indexOf(this.searchQuery.toLowerCase()) >= 0
            );
          }
        );
      }
    } else this.filteredPlayers = this.leaderboardPlayers;
  }

  private async refreshLeaderboard(refresher) {
    if(1) {
      if(this.showTeam) {
        this.newCompTeamLeaderboard(refresher);
      }else this.newCompLeaderboard(refresher);
      return;
    }



    let loader = await this.loadingCtl.create({
      message: 'Refreshing Leaderboard. Please wait...',
    });
    this.leaderboards = createLeaderboardDetails();
    this.errorObj = createLeaderboardDetails();
    this.refreshedAttempt = false;

    await loader.present().then(() => {
      this.compService.getLeaderboard(this.competition.competitionId).subscribe(
        (leaderboards: Leaderboard) => {
          loader.dismiss().then(() => {
            this.refreshedAttempt = true;

            this.leaderboards = leaderboards;
            this.leaderboardPlayers = this.leaderboards.players;
            this.filteredPlayers = this.leaderboardPlayers;
            if (this.filteredPlayers)
              this.filteredPlayers.forEach((fp: LeaderboardPlayerExt) => {
                fp.showScores = false;
              })
            // this.filteredPlayers.sort((a: LeaderboardPlayerExt, b: LeaderboardPlayerExt)=>{
            //   if(a?.compStatus === 'Withdrawn' && b?.compStatus === 'Withdrawn') {
            //     if(this.filteredByScoreType === 'G') {
            //       if(a?.totalGross === 0 && b?.totalGross > 0) return 1;
            //       else if(a?.totalGross > 0 && b?.totalGross === 0) return -1;
            //       else if(a?.totalGross > 0 && b?.totalGross > 0) {
            //         if(a?.totalGross < b?.totalGross) return -1;
            //         else if(a?.totalGross > b?.totalGross) return 1;
            //         else return 0;
            //       } else return 0;
            //     } else if(this.filteredByScoreType === 'N') {
            //       if(a?.totalNet === 0 && b?.totalNet > 0) return 1;
            //       else if(a?.totalNet > 0 && b?.totalNet === 0) return -1;
            //       else if(a?.totalNet < b?.totalNet) return -1;
            //       else if(a?.totalNet > b?.totalNet) return 1;
            //       else return 0;
            //     } else if(this.filteredByScoreType === 'P') {
            //       if(a?.totalPoints === 0 && b?.totalPoints > 0) return -1;
            //       else if(a?.totalPoints > 0 && b?.totalPoints === 0) return 1;
            //       else if(a?.totalPoints < b?.totalPoints) return 1;
            //       else if(a?.totalPoints > b?.totalPoints) return -1;
            //       else return 0;
            //     }
            //     else return 0;
            //   }
            // })
            this.doneRefresh = true;
          });
        },
        (error) => {
          loader.dismiss();
          this.doneRefresh = false;
          this.errorObj = error;
          // let msg = "";

          if (refresher) refresher.complete();
          if (!this.connService.isConnected()) {
            this.errorMsg =
              'Loading leaderboard failed because your internet connection is down';
          } else
            this.errorMsg = MessageDisplayUtil.getErrorMessage(
              error,
              'Loading leaderboard timed out. Please refresh'
            );

          MessageDisplayUtil.showErrorToast(
            this.errorMsg,
            this.platform,
            this.toastCtl,
            1000,
            'bottom'
          );
        },
        () => {
          if (refresher) refresher.complete();

          // if (this.platform.is('ios') && this.platform.is('capacitor'))
          //   this.keyboard.close();
        }
      );
    });
  }

  private async refreshCompetitionDetails() {
    let loader = await this.loadingCtl.create({
      message: 'Please wait...',
    });

    this.refreshedAttempt = false;
    await loader.present().then(
      () => {
        this.compService
          .getDetails(this.competition.competitionId)
          // .subscribe((details: CompetitionDetails) => {
          .subscribe(
            (details: any) => {
              this.details = details;
              this.categories = this.details.categories;
              if(this.showTeam) {
                this.newCompTeamLeaderboard();
              } else this.newCompLeaderboard(null);
              if(loader) loader.dismiss();
              // this.compService
              //   .getLeaderboard(this.competition.competitionId)
              //   .subscribe(
              //     (leaderboards: Leaderboard) => {
              //       loader.dismiss().then(() => {
              //         this.refreshedAttempt = true;
              //         this.leaderboards = leaderboards;
              //         this.leaderboardPlayers = this.leaderboards.players;
              //         this.filteredPlayers = this.leaderboardPlayers;

              //       });
              //     },
              //     (error) => {
              //       loader.dismiss();
              //       this.errorObj = error;
              //     },
              //     () => {
              //       // if (this.platform.is('ios') && this.platform.is('capacitor'))
              //       //   this.keyboard.close();
              //     }
              //   );
            },
            (error) => {
              loader.dismiss().then(() => {
                MessageDisplayUtil.showErrorToast(
                  'Error getting competition details',
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
              });
            },
            () => { }
          );
      },
      (error) => {

      }
    );
  }

  private _setLeaderboardFilter(firstRefresh = false) {

    let selectedRoundNo;

    if (this.selectedRoundNo == 0) selectedRoundNo = '';
    else if (this.competition.totalRounds == 1) selectedRoundNo = '';
    else selectedRoundNo = this.selectedRoundNo;
    this.compService.setLeaderboardFilter(
      this.selectedSortBy,
      selectedRoundNo,
      this.selectedCategoryId,
      this.showTeam
    );
    if (!firstRefresh) this.refreshLeaderboard(null);
  }

  public async openCategory() {
    let tempCategoryName = '';
    if (this.categories.length > 0) tempCategoryName = 'All Categories';
    else tempCategoryName = 'No Category';

    let buttons = [
      {
        text: 'Cancel',
        role: 'cancel', // will always sort to be on the bottom
        icon: !this.platform.is('ios') ? 'close' : null,
        handler: () => {
          actionSheet.dismiss();
          return false;
        },
      }, {
        text: tempCategoryName,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          actionSheet.dismiss().then(() => {
            this.selectedCategoryId = '';
            this._setLeaderboardFilter();
            this.showCategoryName = tempCategoryName;
          });
          return false;
        },
      }
    ];
    this.categories.forEach((c: CompetitionCategory) => {


      if (c.forGrouping) {

        buttons.push({
          text:
            c.categoryName + ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')',
          role: 'destructive',
          icon: 'filter',
          handler: () => {
            actionSheet.dismiss().then(() => {

              this.showCategoryName =
                c.categoryName +
                ' (' +
                c.fromHandicap +
                ' - ' +
                c.toHandicap +
                ')';
              this.selectedCategoryId = String(c.categoryId);
              this._setLeaderboardFilter();
            });
            return false;
          },
        })
      }
    });

    let actionSheet = await this.actionSheetCtl.create({
      buttons: buttons
    });
    await actionSheet.present();
  }

  public async openSortBy() {
    // this.showSortBy = "";
    let _netPtsText = 'Net';
    if (this.scoringFormat !== 'Strokeplay') _netPtsText = 'Points'
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Gross',
          role: 'destructive',
          icon: !this.platform.is('ios') ? 'exit' : null,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.toggleSortBy('gross');
            });
            return false;
          },
        },
        {
          text: _netPtsText,
          icon: !this.platform.is('ios') ? 'cog' : null,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.toggleSortBy('net');
            });
            return false;
          },
        },
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });

    await actionSheet.present();
  }

  public async openRound() {
    let roundNo = this.competition.totalRounds;
    let buttons: any = [{
      text: 'Cancel',
      role: 'cancel', // will always sort to be on the bottom
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        actionSheet.dismiss();
        return false;
      },
    }];
    //
    buttons.push({
      text: 'Overall',
      role: 'destructive',
      icon: !this.platform.is('ios') ? 'exit' : null,
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.showRoundNo = 'Overall';
          this.selectedRoundNo = 0;
          this.roundNo = 0;
          this._setLeaderboardFilter();
        });
        return false;
      },
    });
    //
    for (let i = 1; i <= roundNo; i++) {
      let button = {
        text: 'Round ' + i,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          actionSheet.dismiss().then(() => {

            this.showRoundNo = 'Round ' + i;
            this.selectedRoundNo = i;
            this.roundNo = i;
            this._setLeaderboardFilter();
          })

          return false;

          //  this.goScorecard();
        },
      }
      buttons.push(button);
    }
    let actionSheet = await this.actionSheetCtl.create({
      buttons: buttons
    });
    actionSheet.present();
  }

  onChangeRound(roundNo: number) {
    this.showRoundNo = 'Round ' + roundNo;
    this.selectedRoundNo = roundNo;
    this.roundNo = roundNo;
    this._setLeaderboardFilter();
  }


  getSortBy(sortBy: string) {
    // defining class

    if (
      sortBy == 'gross' &&
      this.searchCriteria.competitionLeaderboardSortBy == 2
    )
      return 'sortedBy';
    if (
      sortBy == 'net' &&
      (this.searchCriteria.competitionLeaderboardSortBy == 3 ||
        this.searchCriteria.competitionLeaderboardSortBy == 4)
    )
      return 'sortedBy';
  }

  toggleSortBy(sortBy: string) {
    console.debug("toggling sort by ", this.showSortBy, this.filteredByScoreType, sortBy);
    if (this.showSortBy.toLowerCase() == sortBy) return false;

    if (sortBy === 'gross') {
      this.showSortBy = 'Gross';
      this.selectedSortBy = 2;
      this.filteredByScoreType = 'G';
      this._setLeaderboardFilter();
      this.sortToggle = true;
    } else if (sortBy === 'net') {
      this.filteredByScoreType = 'N';
      if (this.scoringFormat != 'Stableford' && this.scoringFormat != 'Peoria')
        this.selectedSortBy = 3;
      if (this.scoringFormat == 'Stableford' || this.scoringFormat == 'Peoria')
        this.selectedSortBy = 4;
      // if (this.scoringFormat !== 'Strokeplay')
      //   this.showSortBy = "Points"
      // else
      this.showSortBy = "Net"
      this.sortToggle = false;

      this._setLeaderboardFilter();
    } else if(sortBy === 'points') {
      this.showSortBy = "Points"
      this.filteredByScoreType = 'P';
      this._setLeaderboardFilter();
    }
  }

  // async getPlayerScorecard(playerId: string) {
  //   let loader = await this.loadingCtl.create({
  //     dismissOnPageChange: true,
  //     showBackdrop: false,
  //     cssClass: "nobg"
  //   });
  //   loader.present().then(() => {
  //     this.scorecardService.getCompetitionScorecard(this.competition.competitionId, this.selectedRoundNo, Number(playerId), true)
  //       .subscribe((scorecard: PlainScorecard) => {
  //         loader.dismiss().then(() => {
  //           let subTitle = "No scorecard to display";
  //           if (scorecard) {
  //             this.nav.push(ScorecardDisplayPage, {
  //               scorecard: scorecard,
  //               editing: true
  //             });
  //           } else MessageDisplayUtil.displayInfoAlert(this.alertCtrl, "", subTitle, "OK");


  //         });
  //       }, (error) => {
  //         loader.dismiss().then(() => {
  //           let subTitle = "No scorecard to display";
  //           MessageDisplayUtil.displayInfoAlert(this.alertCtrl, "", subTitle, "OK");
  //         });

  //       }, () => {

  //       });
  //   });

  // }

  public async openTeams() {
    let tempTeamName = '';
    if (this.compTeams.totalItems > 0) tempTeamName = 'All Teams';
    else tempTeamName = 'No Team';
    let buttons: any = [{
      text: 'Cancel',
      role: 'cancel', // will always sort to be on the bottom
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        actionSheet.dismiss();
        return false;
      }
    }, {
      text: tempTeamName,
      role: 'destructive',
      icon: 'filter',
      handler: () => {
        actionSheet.dismiss().then(() => {
          this.selectedCategoryId = '';
          this._setLeaderboardFilter();
          return false;
        });

        //  this.goScorecard();
      },
    }];


    this.compTeams.competitionTeams.forEach((c: Teams) => {
      buttons.push({
        text: c.teamName,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          actionSheet.dismiss().then(() => {

            this.showCategoryName = c.teamName;
            this.selectedCategoryId = String(c.teamId);
            this._setLeaderboardFilter();
            return false;
          });
        },
      });
    });

    let actionSheet = await this.actionSheetCtl.create({
      buttons: buttons
    });
    await actionSheet.present();
  }

  async goTeamFilter() {
    // let modal = await this.modalCtl.create({
    //   component:CompetitionLeaderboardTeamFilter,
    //   componentProps:{
    //     compTeams: this.compTeams
    //   }
    // });
    // modal.onDidDismiss().then((data: any) => {
    //   if (!data) return;
    //   if (data.all && this.selectedCategoryId !== "") {
    //     this.selectedCategoryId = "";
    //     this.showCategoryName = "All Teams";
    //     this._setLeaderboardFilter();
    //   } else if (data.team && this.selectedCategoryId !== String(data.team.teamId)) {
    //     this.showCategoryName = data.team.teamName;
    //     this.selectedCategoryId = String(data.team.teamId);
    //     this._setLeaderboardFilter();
    //   }
    // });
    // modal.present();
  }

  checkScoringCategory() {
    let hasScoringCategory: boolean = false;
    this.categories.forEach((c: CompetitionCategory) => {
      if (c.forGrouping) {

        hasScoringCategory = true;
        // return c.forGrouping
      }
    });
    return hasScoringCategory;
  }

  //

  onBackpage() {
    this.location.back();
  }
  goHome() {

    this.router.navigate(['tabs/player-home']);
  }
  getAllScores(player: LeaderboardPlayerExt) {
    if (!player) return;
    if (this.showTeam) return;
    if (this.roundNo === 0) return;
    // if(1) { // use new scorecards API
    //   this.getScorecardsByPlayer(player);
    //   // return;
    // }
    player.showScores = !player.showScores;

    let _params = {
      competitionId: this.competition.competitionId,
      playerId: player.playerId
    }
    this.flightService.getCompPlayerAllScores(_params)
      .subscribe((data: Array<CompetitionRound>) => {
        if (data) {
          let _filteredRoundScores = data.filter((scores: CompetitionRound) => {
            return scores && scores.roundNo === this.roundNo;
          }).map(scores => scores);


          let _getIndex = this.filteredPlayers.findIndex((fp: LeaderboardPlayerExt) => {
            return fp.playerId === player.playerId
          })
          this.filteredPlayers[_getIndex].competitionRound = [];
          this.filteredPlayers[_getIndex].competitionRound.push(...data)

        }
        // filter by round as well
      })
  }

  getRoundTotalNines() {
    if(!this.compData) return;
    let _currRound = this.compData?.gameRounds?.find((g: GameRoundData) => {
      return g.roundNo === this.roundNo
    })
    // console.debug("get round total [nines]", _currRound?.gameRoundCourses?.length)
    return _currRound?.gameRoundCourses?.length;
  }

  getArrayRange(nines: number, start?: number): Array<number> {
    // console.debug("get array range [nines]", nines, start, this.mg2uUtils.getRange(nines, start))
    return this.mg2uUtils.getRange(nines, start);
  }
  getScorecardHeader(player: LeaderboardPlayerExt, attribute: string, whichNine?: number, compRound?: CompetitionRound) {
    if (!player) return ;
    if (player && !player.competitionRound) return;
    // if(!compRound) return;
    // let _details = compRound.nines;
    // if(_details && !_details.holeIndexes) return;
    // if(_details && _details.holeIndexes.length === 0) return;
    // if(!_details) return;
    let _scoreDetails = player.competitionRound.filter((compRound: CompetitionRound) => {
      return compRound.roundNo === this.roundNo
    }).pop();
    // .map((cr)=>{
    //   return cr
    // })
    let _nine = 9;
    let _minNine = _nine * (whichNine - 1);

    let _indexes = [];
    let _pars = [];
    let _gross = [];
    let _net = [];
    let _points = [];
    let _shotsAllowed = [];
    let _holeScores
    let _scores;
    _scoreDetails.nines.filter((scores) => {
      return scores.nine === whichNine
    }).map((s) => {
      _scores = s.scores;
    });

    if (_scores) {
      _scores.forEach((s: any, idx) => {
        _indexes.push(s.index)
        _pars.push(s.parScore)
        _gross.push(s.grossScore)
        _net.push(s.netScore)
        _points.push(s.points)
        _shotsAllowed.push(s.shotsAllowed)
      })
    }
    //  _details.holeIndexes.filter((v,i)=>{
    //   if(whichNine === 1) return i<_nine
    //   else return i>= _minNine && i<_nine*whichNine
    // });

    //  = _details.holePars.filter((v,i)=>{
    //   if(whichNine === 1) return i<_nine
    //   else return i>= _minNine && i<_nine*whichNine
    // });

    switch (attribute) {
      // case 'holeNo':
      //   if(whichNine === 1) {
      //     return details.
      //   }

      case 'holeIndex':
        return _indexes;
      case 'holePar':
        return _pars;
      case 'gross':
        return _gross;
      case 'net':
        return _net;
      case 'points':
        return _points;
      // case 'totalGrossIn':
      //   return _scoreDetails.inTotal;
      // case 'totalGrossOut':
      //   return _scoreDetails.outTotal;
      // case 'totalNetIn':
      //   return _scoreDetails.inTotalNet;
      // case 'totalNetOut':
      //   return _scoreDetails.outTotalNet;
      //   case 'totalPointsIn':
      //     return _scoreDetails.inPoints;
      //   case 'totalPointsOut':
      //     return _scoreDetails.outPoints;
        case 'shotsAllowed':
          return _shotsAllowed;
    }
  }

  getScorecardValue(player: LeaderboardPlayerExt, attribute: string, whichNine?: number, compRound?: CompetitionRound) {
    if (!player) return ;
    if (player && !player.competitionRound) return;
    // if(!compRound) return;
    // let _details = compRound.nines;
    // if(_details && !_details.holeIndexes) return;
    // if(_details && _details.holeIndexes.length === 0) return;
    // if(!_details) return;
    let _scoreDetails = player.competitionRound.filter((compRound: CompetitionRound) => {
      return compRound.roundNo === this.roundNo
    }).pop();
    // console.debug("get scorecard value : ", player, attribute, whichNine)
    // .map((cr)=>{
    //   return cr
    // })
    let _nine = 9;
    let _minNine = _nine * (whichNine - 1);

    let _indexes = [];
    let _pars = [];
    let _gross = [];
    let _net = [];
    let _points = [];
    let _shotsAllowed = [];
    let _holeScores
    let _scores;
    let _courseScores;
    _scoreDetails.nines.filter((scores) => {
      return scores.nine === whichNine
    }).map((s) => {
      _scores = s.scores;
      _courseScores = s;
    });
    // console.debug("get scorecard value : ", _scoreDetails, _courseScores)

    if (_scores) {
      _scores.forEach((s: any, idx) => {
        _indexes.push(s.index)
        _pars.push(s.parScore)
        _gross.push(s.grossScore)
        _net.push(s.netScore)
        _points.push(s.points)
        _shotsAllowed.push(s.shotsAllowed)
      })
    }
    switch (attribute) {
      case 'totalGrossIn':
        return _scoreDetails.inTotal;
      case 'totalGrossOut':
        return _scoreDetails.outTotal;
      case 'totalNetIn':
        return _scoreDetails.inTotalNet;
      case 'totalNetOut':
        return _scoreDetails.outTotalNet;
      case 'totalGross':
        return _courseScores.grossTotal;
      case 'totalNet':
        return _courseScores.netTotal;
        case 'totalPoints':
          return _courseScores.pointsTotal;
          // if(_scoreDetails?.)
        case 'totalPointsIn':
          return _scoreDetails.inPoints;
        case 'totalPointsOut':
          return _scoreDetails.outPoints;
    }
  }
  deriveClasses(player: LeaderboardPlayerExt, idx: number, whichNine?: number) {
    if (!player) return;
    if (player && !player.competitionRound) return;
    let _scoreDetails = player.competitionRound.filter((compRound: CompetitionRound) => {
      return compRound.roundNo === this.roundNo
    }).pop();
    // .map((cr)=>{
    //   return cr
    // })
    let _nine = 9;
    let _minNine = _nine * (whichNine - 1);

    let _indexes = [];
    let _pars = [];
    let _gross = [];
    let _net = [];
    let _holeScores
    let _scores;
    _scoreDetails.nines.filter((scores) => {
      return scores.nine === whichNine
    }).map((s) => {
      _scores = s.scores;
    });

    if (_scores) {
      _scores.forEach((s: any, idx) => {

        _indexes.push(s.index)
        _pars.push(s.parScore)
        _gross.push(s.grossScore)
        _net.push(s.netScore)
      })
    }
    let diff = _scores[idx].grossScore - _scores[idx].parScore
    let result = "";
    switch (diff) {
      case -3:
        result = "score-albatross";
        break;
      case -2:
        result = "score-eagle"
        break;
      case -1:
        result = "score-birdie";
        break;
      case 0:
        result = "score-par"
        break;
      case 1:
        result = "";
        break;
      case 2:
        result = "";
        break;
      case 3:
        result = "";
        break;
      default:
        result = ""
    }
    return "score-normal " + result;
  }

  getCompImage() {
    if(this.competition.thumbnail)
      return this.competition.thumbnail
    else return this.competition.imageUrl
  }

  getScorecardsByPlayer(player: LeaderboardPlayerExt) {
    player.showScores = !player.showScores;
    let _compId = this.competition?.competitionId || this.compData?.id;
    let _playerId = player.playerId;
    this.flightService.getCompScorecardsByPlayer(_compId, _playerId)
    .subscribe((scorecard: PlayerScorecard)=>{
      console.debug("get scorecards by player ", player, scorecard)


        let _getIndex = this.filteredPlayers.findIndex((fp: LeaderboardPlayerExt) => {
          return fp.playerId === player.playerId
        })
        console.debug("get scorecards by player ", this.filteredPlayers[_getIndex])
        // this.filteredPlayers[_getIndex].competitionRound = [];
        // this.filteredPlayers[_getIndex].competitionRound.push(...data)

    })
  }

  async newCompLeaderboard(refresher) {
    let _compId = this.compId || this.competition?.competitionId || this.compData?.id;
    let _params = {
      roundNo: this.roundNo,
      category: this.selectedCategory?this.selectedCategory.id:null,
      scoreType: this.filteredByScoreType,
    }
    if(this.roundNo === 0) delete _params['roundNo'];
    let loader = await this.loadingCtl.create({
      message: 'Refreshing Leaderboard. Please wait...',
    });
    this.leaderboards = createLeaderboardDetails();
    this.errorObj = createLeaderboardDetails();
    this.refreshedAttempt = false;

    // loader.onDidDismiss().then(() => {
    //   if (refresher) {
    //     refresher.detail.complete();
    //   }
    // });
    await loader.present().then(() => {
      this.flightService.getCompLeaderboard(_compId, _params)
      .subscribe((leaderboard: LeaderBoard)=>{
        console.debug("new comp leaderboard", leaderboard)

          loader.dismiss().then(() => {
            this.refreshedAttempt = true;

            this.leaderboards = leaderboard;
            this.leaderboardPlayers = this.leaderboards.players;
            this.filteredPlayers = this.leaderboardPlayers;
            if (this.filteredPlayers) {

              this.filteredPlayers.forEach((fp: LeaderboardPlayerExt) => {
                fp.showScores = false;
              })

            this.filteredPlayers.sort((a: LeaderboardPlayerExt, b: LeaderboardPlayerExt)=>{
              if(a?.compStatus === 'Withdrawn' && b?.compStatus === 'Withdrawn') {
                if(this.filteredByScoreType === 'G') {
                  if(a?.totalGross === 0 && b?.totalGross > 0) return 1;
                  else if(a?.totalGross > 0 && b?.totalGross === 0) return -1;
                  else if(a?.totalGross > 0 && b?.totalGross > 0) {
                    if(a?.totalGross < b?.totalGross) return -1;
                    else if(a?.totalGross > b?.totalGross) return 1;
                    else return 0;
                  } else return 0;
                } else if(this.filteredByScoreType === 'N') {
                  if(a?.totalNet === 0 && b?.totalNet > 0) return 1;
                  else if(a?.totalNet > 0 && b?.totalNet === 0) return -1;
                  else if(a?.totalNet > 0 && b?.totalNet > 0) {
                    if(a?.totalNet < b?.totalNet) return -1;
                    else if(a?.totalNet > b?.totalNet) return 1;
                    else return 0;
                  } else return 0;
                } else if(this.filteredByScoreType === 'P') {
                  if(a?.totalPoints === 0 && b?.totalPoints > 0) return -1;
                  else if(a?.totalPoints > 0 && b?.totalPoints === 0) return 1;
                  else if(a?.totalPoints > 0 && b?.totalPoints > 0) {
                    if(a?.totalPoints < b?.totalPoints) return 1;
                    else if(a?.totalPoints > b?.totalPoints) return -1;
                    else return 0;
                  } else return 0;
                }
                else return 0;
              }
            })
            }
            this.doneRefresh = true;
            if (refresher)
            refresher.detail.complete();
          });
        },
        (error) => {
          loader.dismiss();
          this.doneRefresh = false;
          this.errorObj = error;
          // let msg = "";

          if (refresher) refresher.detail.complete();
          if (!this.connService.isConnected()) {
            this.errorMsg =
              'Loading leaderboard failed because your internet connection is down';
          } else
            this.errorMsg = MessageDisplayUtil.getErrorMessage(
              error,
              'Loading leaderboard timed out. Please refresh'
            );

          MessageDisplayUtil.showErrorToast(
            this.errorMsg,
            this.platform,
            this.toastCtl,
            1000,
            'bottom'
          );
        },
        () => {
          if (refresher) refresher.detail.complete();

          // if (this.platform.is('ios') && this.platform.is('capacitor'))
          //   this.keyboard.close();
        })
      })
  }

  compOCBs: Array<any>;

  async onClickOcbStat(player, type: string) {
    if(!player) return;
    if(type === 'gross' && !player.grossOcbStat) return;
    if((type === 'net' || type === 'points') && !player.netOcbStat) return;
    let _message = {};
    let _stat = '';
    let _title = '';
    let _prevIdx = this.filteredPlayers.findIndex((fp: LeaderboardPlayerExt) => fp.playerId === player.playerId);
    let _prevPlayer = this.filteredPlayers[_prevIdx - 1];
    let _subtitle = `${player?.playerName} against ${_prevPlayer?.playerName}`
    if(type === 'gross' && player.grossOcbStat) {
      _stat = player.grossOcbStat
      _stat = _stat.replace(/\n/g, '<br>');
      _stat = this.parseReplaceOCB(_stat)

      _title = 'OCB for Gross'
      _message = {
        title: _title,
        content: _stat
      }
    } else if((type === 'net' || type === 'points') && player.netOcbStat) {
      _stat = player.netOcbStat
      _stat = _stat.replace(/\n/g, '<br>');
      _stat = this.parseReplaceOCB(_stat)

      _title = `OCB for ${type==='net'?'Net':'Points'}`,
      _message = {
        title: _title,
        content: _stat
      }
    }
    console.debug("click tooltip : ", _message);

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          headerTitle: _subtitle,
          message: _message,
          mode: 'infoDisplay',
      }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("pullup dismiss", data)
      if(data) {
      }
    })
  }

  parseReplaceOCB(ocbStat: string) {
    const parts = ocbStat.split('<br>');
    console.debug(" parse replace ocb [0] : ", parts, ocbStat, this.compOCBs);

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const regex = /\((.*?)\)/;
        const match = part.match(regex);
        const index = this.compOCBs.findIndex(item => part.includes(item?.mergedDetails));
        if (index !== -1) {
              parts[i] = this.compOCBs[index]?.ocb?.name + ' ' + this.compOCBs[index]?.mergedDetails + ' (' + match[1] + ')';
          }
        console.debug(" parse replace ocb [1] : ", part, match);
    }

    console.debug(" parse replace ocb [2] : ", parts.join(' '));
    return parts.join('<br>');
  }
  onToggleShowStrokes(player: LeaderboardPlayerExt) {
    player.showStrokes = !player.showStrokes;
  }

  getScorecardStrokes(player: LeaderboardPlayerExt, whichNine?: number) {

    let _scoreDetails = player.competitionRound.filter((compRound: CompetitionRound) => {
      return compRound.roundNo === this.roundNo
    }).pop();
    let _scores;
    _scoreDetails.nines.filter((scores) => {
      return scores.nine === whichNine
    }).map((s) => {
      _scores = s.scores;
    });
    let _shotsAllowed = [];
    if (_scores) {
      _scores.forEach((s: any, idx) => {
        // let _shots = s.shotsAllowed<0?-1*s.shotsAllowed:s.shotsAllowed;
        let _shots = s.shotsAllowed;
        _shotsAllowed.push(Number(_shots))
      })
    }
    console.debug(" get scorecard strokes", player, whichNine, _shotsAllowed,Number(_scores.shotsAllowed))
  return _shotsAllowed;
  }


  strokesList: Array<string> = ['1stroke.svg','2strokes.svg','3strokes.svg'];
  getStrokesImg(shotsAllowed: number) {
    if(shotsAllowed === 0 || !shotsAllowed || shotsAllowed === undefined) return;
    let _idx = shotsAllowed - 1
    return 'assets/icons/' + this.strokesList[_idx];
  }

  getCircleNumber(n: number) {
    let _n = n;
    if(n < 0) _n = -1 * n;
    let _numbers = Array(_n).fill(1);
    return _numbers;
  }

  getShotsAllowed(player: LeaderboardPlayerExt, idx: number, whichNine: number) {
    let _scoreDetails = player.competitionRound.filter((compRound: CompetitionRound) => {
      return compRound.roundNo === this.roundNo
    }).pop();
    let _scores;
    _scoreDetails.nines.filter((scores) => {
      return scores.nine === whichNine
    }).map((s) => {
      _scores = s.scores;
    });
    return _scores[idx].shotsAllowed;
  }

  selectedCategory: PlayerCategoryData;
  compPlayerCategories: Array<PlayerCategoryData> = [];
  async onChangeCategory() {
    let _dataList = [];

    _dataList.push({
      id: null,
      name: 'All Categories',
    })
    // this.compPlayerCategories.filter((category: PlayerCategoryData) => {
    //   return category.forGrouping
    // })
    this.getCompPlayerCategories().forEach((category: PlayerCategoryData) => {
      _dataList.push({
        id: category.id,
        name: `${category.name} (HCP ${category.fromHandicap} to ${category.toHandicap})`
      })
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          dataList: _dataList,
          headerTitle: 'Show by Category',
          mode: 'common',
      }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("pullup dismiss", data)
      if(data?.data) {
        this.selectedCategory = this.compPlayerCategories.find((category)=>{
          if(data?.data?.id)
            return category.id === data.data.id
          else return null;
        });
        this.refreshLeaderboard(null);
      }
    })
  }

  getCategoryInfo() {
    if(!this.selectedCategory) return 'All Categories';
    return `Category ${this.selectedCategory.name} (HCP ${this.selectedCategory.fromHandicap} to ${this.selectedCategory.toHandicap})`;
  }

  showHandicap() {
    if(this.compData?.proCompetition) return false;
    if(this.compData?.status === 'Completed') return true;
    if(!this.compData?.handicapFormat) return true;
    if(this.compData?.totalRounds <= 1) {
      if(this.compData?.handicapFormat) {
        if(this.compData?.handicapFormat?.name.toLowerCase().includes('peoria') || this.compData?.handicapFormat?.name.toLowerCase() === 'system36') {
          return false;
        } else return true;
      } else return true;
    } else if(this.compData?.totalRounds > 1) {
      let _round = this.compData.gameRounds.find((round: GameRoundInfo)=>{
        return round.roundNo === this.roundNo
      })
      if(_round?.status === 'Completed') return true;
      else {
        if(this.compData?.handicapFormat) {
          if(this.compData?.handicapFormat?.name.toLowerCase().includes('peoria') || this.compData?.handicapFormat?.name.toLowerCase() === 'system36') {
            return false;
          } else return true;
        } else return true;
      }
    }
  }

  toNumber(str: string): number {
    return Number(str);
  }

  filteredTeams: Array<TeamScores> = [];
  async newCompTeamLeaderboard(refresher?) {

    let _compId = this.competition?.competitionId || this.compData?.id;
    let _params = {
      competitionId: _compId,
      grossOrNet: this.filteredByScoreType.toLowerCase(),
    }
    let loader = await this.loadingCtl.create({
      message: 'Refreshing Leaderboard. Please wait...',
    });
    this.leaderboards = createLeaderboardDetails();
    this.errorObj = createLeaderboardDetails();
    this.refreshedAttempt = false;
    if(refresher) this.filteredTeams = [];

    await loader.present().then(() =>{
      this.flightService.getCompTeamScores(_params)
      .subscribe((teamScores: Array<TeamScores>)=>{
        console.debug("new comp team leaderboard", _params, teamScores)
        if(teamScores?.length > 0) {
          this.filteredTeams = teamScores;
        }
        this.refreshedAttempt = true;
        if(loader) loader.dismiss().then(()=>{});
        if(refresher) refresher.detail.complete();
      },(error)=>{
        this.refreshedAttempt = true;
        if(loader) loader.dismiss().then(()=>{});
        if(refresher) refresher.detail.complete();
      })
    })

    // await loader.present().then(() => {
    //   this.flightService.getCompLeaderboard(_compId, _params)
    //   .subscribe((leaderboard: LeaderBoard)=>{
    //     console.debug("new comp leaderboard", leaderboard)

    //       loader.dismiss().then(() => {
    //         this.refreshedAttempt = true;

    //         this.leaderboards = leaderboard;
    //         this.leaderboardPlayers = this.leaderboards.players;
    //         this.filteredPlayers = this.leaderboardPlayers;
    //         if (this.filteredPlayers)
    //           this.filteredPlayers.forEach((fp: LeaderboardPlayerExt) => {
    //             fp.showScores = false;
    //           })
    //         this.doneRefresh = true;
    //         if (refresher)
    //         refresher.detail.complete();
    //       });
    //     },
    //     (error) => {
    //       loader.dismiss();
    //       this.doneRefresh = false;
    //       this.errorObj = error;
    //       // let msg = "";

    //       if (refresher) refresher.detail.complete();
    //       if (!this.connService.isConnected()) {
    //         this.errorMsg =
    //           'Loading leaderboard failed because your internet connection is down';
    //       } else
    //         this.errorMsg = MessageDisplayUtil.getErrorMessage(
    //           error,
    //           'Loading leaderboard timed out. Please refresh'
    //         );

    //       MessageDisplayUtil.showErrorToast(
    //         this.errorMsg,
    //         this.platform,
    //         this.toastCtl,
    //         1000,
    //         'bottom'
    //       );
    //     },
    //     () => {
    //       if (refresher) refresher.detail.complete();

    //       // if (this.platform.is('ios') && this.platform.is('capacitor'))
    //       //   this.keyboard.close();
    //     })
    //   })
  }

  getTeamRoundScore(team: TeamScores, roundNo: number) {
    if(this.filteredByScoreType.toLowerCase() === 'n') {
      return team?.roundScores[roundNo - 1]?.topNTotalNet;
    } else if(this.filteredByScoreType.toLowerCase() === 'p') {
      return '-';
    } else {
      return team?.roundScores[roundNo - 1]?.topNTotalGross;
    }
  }

  getTeamScore(team) {
    if(this.filteredByScoreType.toLowerCase() === 'n') {
      return team?.topNTotalNet;
    } else if(this.filteredByScoreType.toLowerCase() === 'p') {
      return '-';
    } else {
      return team?.topNTotalGross;
    }
  }

  getClassScoreType() {
    if(this.filteredByScoreType.toLowerCase() === 'n') {
      return 'col-net';
    } else if(this.filteredByScoreType.toLowerCase() === 'p') {
      return 'col-point'
    } else {
      return 'col-gross'
    }
  }

  getTeamRoundToPar(team: TeamScores, roundNo: number) {
    if(this.filteredByScoreType.toLowerCase() === 'n') {
      return team?.roundScores[roundNo - 1]?.topNToParNet;
    } else if(this.filteredByScoreType.toLowerCase() === 'p') {
      return '-';
    } else {
      return team?.roundScores[roundNo - 1]?.topNToPar;
    }
  }

  getTeamRoundScores(team: TeamScores) {
    if(!team) return [];
    return team.roundScores;
  }

  getAccumulativeTeamToPar(team: TeamScores) {
    if(this.selectedRoundNo === 0) {
      if(this.filteredByScoreType === 'N') {
        return team?.topNToParNet;
      } else if(this.filteredByScoreType === 'P') {
        return '-';
      } else {
        return team?.topNToPar;
      }
    } else {
      const roundScores = this.getTeamRoundScores(team);
      let _totalPar = roundScores.filter((r: TeamRoundScores, idx: number) => idx < this.selectedRoundNo)
      .map((r: TeamRoundScores) => {
        if(this.filteredByScoreType.toLowerCase() === 'n') {
          return r.topNToParNet
        } else if(this.filteredByScoreType.toLowerCase() === 'p') {
          return 0
        } else return r.topNToPar
      }).reduce((a, b) => a + b, 0);
      this.getTeamRoundToPar(team, this.selectedRoundNo);
      if(this.filteredByScoreType === 'N') {
        return _totalPar
      } else if(this.filteredByScoreType === 'P') {
        return _totalPar
      } else {
        return _totalPar
      }
    }

  }

  getAccumulativeTeamScore(team: TeamRoundScores) {

    if(this.selectedRoundNo === 0) {
      if(this.filteredByScoreType === 'N') {
        return team?.topNTotalNet;
      } else if(this.filteredByScoreType === 'P') {
        return '-';
      } else {
        return team?.topNTotalGross;
      }
    } else {
      const roundScores = this.getTeamRoundScores(team);
      let _totalScore = roundScores.filter((r: TeamRoundScores, idx: number) => idx < this.selectedRoundNo)
      .map((r: TeamRoundScores) => {
        if(this.filteredByScoreType.toLowerCase() === 'n') {
          return r.topNTotalNet
        } else if(this.filteredByScoreType.toLowerCase() === 'p') {
          return 0
        } else return r.topNTotalGross
      }).reduce((a, b) => a + b, 0);
      this.getTeamRoundToPar(team, this.selectedRoundNo);
      if(this.filteredByScoreType === 'N') {
        return _totalScore
      } else if(this.filteredByScoreType === 'P') {
        return _totalScore
      } else {
        return _totalScore
      }
    }
  }



  getOtherPlayerStatus(player: LeaderboardPlayerExt) {
    // console.debug("get other plaeyr status : ", this.settings.selectedRound, this.compDetails.roundInProgress);
    let _currRound = this.roundNo || this.details.roundInProgress;
    let _currRoundStatus: string;
    for(let key in player.roundsAbsent) {
        if(Number(key) === _currRound - 1)
            _currRoundStatus = player.roundsAbsent[key];
        else if(this.roundNo === 0 || !this.details.roundInProgress) {
          if(Number(key) ===this.compData?.gameRounds?.length)
            _currRoundStatus = player.roundsAbsent[key];
        }
    }
    if(_currRoundStatus === 'Withdrawn')
        return 'WD';
    else if(_currRoundStatus === 'FailedCutoff')
        return 'CUT';
  }

  getCompPlayerCategories() {
    let _categories = [];
    if(this.compPlayerCategories?.length) {
      _categories = this.compPlayerCategories.filter((pc)=>{
        return pc?.forGrouping
      })
    }
    return _categories;
  }

  getPlayerImage(player) {
    // console.debug("get player image [0] : ", player)
    if (!player) return 'assets/image/default_user.png';
    let _playerImage = '';
    if (player.imageURL) _playerImage = player.imageURL;
    else return 'assets/image/default_user.png';

    // console.debug("get player image [1] : ", global.MygolfServerHost + '/' + _playerImage);
    if(_playerImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _playerImage
    else return global.MygolfServer + '/' + _playerImage;
  }

  isSmallerDevice() {
    return this.platform?.width() <= 320
  }

  displayGrossLabel() {
    return 'GRS';
  }

  displayNetLabel() {
    return 'NET';
  }

  displayPointsLabel() {
    return 'PTS'
  }

  isCurrentRoundInProgress() {
    if(!this.compData) return;
    let _isInProgress = false;
    console.debug("is current round in progress : ", this.compData?.gameRounds, this.selectedRoundNo)
    if(!!this.compData?.gameRounds?.find((round: GameRoundInfo) => {
      if(this.selectedRoundNo > 0) {
        return round?.roundNo === this.selectedRoundNo && round?.status === 'InProgress'
      } else {
        return round?.roundNo === this.compData?.gameRounds?.length && round?.status === 'InProgress'
      }
    })) {
      _isInProgress = true;
    }
    return _isInProgress;
  }

  isHandicapDerived() {
    if(!this.compData) return;
    if(!this.compData?.handicapFormat) return false;
    if(this.compData?.handicapFormat?.name.toLowerCase() === 'msystem36') return false;
    else return true;
  }


  displayToPar(player) {
    if(!player) return null;
    if(this.filteredByScoreType === 'G') {
      return player?.toParGross;
    } else {
      return player?.toParNet;
    }

  }

  subShowLeaderboard: Subscription;
  initWebsocketActions() {

    this.subShowLeaderboard = this.websocketActions.subscribeTo(SUBSCRIBE_COMP_SHOW_LEADERBOARD)
    .subscribe((data: any) => {
      console.debug("get update scorer : ", data, this.compData?.id)
      if(data?.competitionId === this.compData?.id) {
        // this.refreshMatchById();
        if(!data?.showLeaderboard) {
          let _msg = 'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.';
          MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 5000, 'bottom')
          if(this.subShowLeaderboard) {
            this.subShowLeaderboard.unsubscribe();
            this.subShowLeaderboard = null;
          }
          this.onBackpage();
        }
        this.compData.showLeaderBoard = data?.showLeaderboard;
        this.competition.showLeaderBoard = data?.showLeaderboard;
        this.refreshCompetitionDetails();
        this.refreshCompData();
        // MessageDisplayUtil.showErrorToast('Match scorer updated',
        // this.platform, this.toastCtl, 3000, 'bottom' )
      }
    });
  }

  refreshCompData() {

    this.flightService.getCompetitionDetails(this.compData.id)
    .subscribe((compData)=>{
      if(compData) {
        this.compData = compData;
        this.compService.setCompData(compData);
      }
      console.debug("get comp data", compData, this.compData);
    },(error)=>{

    },()=>{
    })
  }

  isLeaderboardDisabled() {
    if(this.competition?.showLeaderBoard !== undefined && !this.competition?.showLeaderBoard) return true;
    else if(this.compData?.showLeaderBoard !== undefined && !this.compData?.showLeaderBoard) return true;
    else return false;
  }
}
